// extracted by mini-css-extract-plugin
export default {"container":"eF30","imgWrapper":"Uw0W","dataWrapper":"jPnI"};